import TableList from "@components/templates/tablelist";
import mixin from '../plan/mixin'
// import { HttpProductList } from '@/service/inbound';
import { mapState, mapGetters } from "vuex";
import { HttpGetDestoryPlanByPage } from '@/service/destory'
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left",
            },
        };
    },
    methods: {
        ajaxRequest: HttpGetDestoryPlanByPage,
        interceptRequest: (params) => {
            console.log(params)
            return {
                ...params,
                search: {
                    ...params.search,
                    'IN_status': [2, 4],
                },
                isManage: true
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getBillcusWareList', 'getFilterDisabledWarehouse']),
        SearchsData() {
            return [{
                label: "销毁计划单号",
                tag: 'vInput',
                key: 'EQ_destroyPlanOrderNo',
                show: true,
            },
            {
                label: "仓库",
                tag: 'Select',
                options: this.getBillcusWareList,
                key: 'EQ_orgWarehouseId',
                props: {
                    filterable: true
                },
                show: true,
            }]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "销毁计划单号",
                key: 'destroyPlanOrderNo'
            }, {
                title: "仓库",
                key: 'orgWarehouseName',
            }, {
                title: '项目',
                key: 'lineName'
            },
            {
                title: '状态',
                key: 'status',
                render: (h, { row }) => {
                    let statusName = this.statusList.filter(item => {
                        return item.value === row.status
                    })[0] || {}
                    return (
                        <div>
                            <div class={statusName.theme || ''}>{statusName.label || '--'}</div>
                        </div>
                    )
                }
            },
            {
                title: "操作",
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, "选择")
                }
            }]
        }
    }

};
